unit DansUserMain;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls,
  XData.Web.Connection, XData.Web.Client, Vcl.StdCtrls, WEBLib.StdCtrls;

type
  TForm1 = class(TForm)
    pnlLogin: TPanel;
    pnlRegister: TPanel;
    pnlReset: TPanel;
    pnlMessage: TPanel;
    edtLoginEmail: TEdit;
    edtLoginPassword: TEdit;
    btnLogin: TButton;
    btnGoToRegister: TButton;
    btnGoToReset: TButton;
    edtRegFirstName: TEdit;
    edtRegLastName: TEdit;
    edtRegPassword2: TEdit;
    edtRegMobil: TEdit;
    edtRegEmail: TEdit;
    edtRegPassword: TEdit;
    btnRegister: TButton;
    btnGoToLogin: TButton;
    edtResetEmail: TEdit;
    btnResetRequest: TButton;
    btnResetGotoLogin: TButton;
    lblMessage: TLabel;
    lblLoginTitle: TLabel;
    lblRegisterTitle: TLabel;
    lblResetTitle: TLabel;
    pnlNewPassword: TPanel;
    edtNewPassword: TEdit;
    edtNewPassword2: TEdit;
    lblResetPasswordTitle: TLabel;
    btnSaveNewPassword: TButton;
    edtLoginCode: TEdit;
    XDataConn: TXDataWebConnection;
    procedure WebFormCreate(Sender: TObject);
    procedure btnLoginClick(Sender: TObject);
    procedure btnGoToRegisterClick(Sender: TObject);
    procedure btnGoToResetClick(Sender: TObject);
    procedure btnRegisterClick(Sender: TObject);
    procedure btnGoToLoginClick(Sender: TObject);
    procedure btnResetRequestClick(Sender: TObject);
    procedure btnResetGotoLoginClick(Sender: TObject);
    procedure btnSaveNewPasswordClick(Sender: TObject);
  private
    FResetToken: string;
    procedure ShowPanel(const APanel: TPanel);
    procedure ShowMsg(const AMsg: string; ASuccess: Boolean);
    procedure NavigateToElev(AUserId, ACode, AToken, ACodeId: string);
  public
  protected procedure LoadDFMValues; override; end;

var
  Form1: TForm1;

implementation

{$R *.dfm}

procedure TForm1.WebFormCreate(Sender: TObject);
begin
  XDataConn.Connected := False;
  XDataConn.URL := 'https://dans.mic.tf/users';

  asm
    var appDiv = document.getElementById('Form1');
    if (appDiv) {
      appDiv.style.overflow = 'visible';
      appDiv.style.position = 'relative';
    }
    document.body.style.background = 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)';
    document.body.style.minHeight = '100vh';
    document.body.style.overflow = 'visible';
    document.querySelectorAll('input[type="password"]').forEach(function(f) {
      f.setAttribute('autocomplete', 'new-password');
    });
    setTimeout(function() {
      var panels = ['pnlLogin', 'pnlRegister', 'pnlReset', 'pnlNewPassword'];
      panels.forEach(function(id) {
        var p = document.getElementById(id);
        if (p) {
          p.style.maxWidth = '380px';
          p.style.width = '90%';
          p.style.margin = '40px auto';
          p.style.position = 'relative';
          p.style.overflow = 'visible';
          p.style.boxSizing = 'border-box';
          var cardBody = p.querySelector('.card-body');
          if (cardBody) {
            cardBody.style.overflow = 'visible';
            cardBody.style.paddingTop = '16px';
            cardBody.style.paddingBottom = '79px';
          }
          p.querySelectorAll('div[id*="Label"]').forEach(function(div) {
            if (div.id === 'lblLoginTitle' ||
                div.id === 'lblRegisterTitle' ||
                div.id === 'lblResetTitle' ||
                div.id === 'lblResetPasswordTitle') {
              return;
            }
            div.setAttribute('style',
              'position: relative !important;' +
              'left: auto !important;' +
              'top: auto !important;' +
              'width: 100% !important;' +
              'display: block !important;' +
              'margin-bottom: 12px !important;' +
              'box-sizing: border-box !important;'
            );
          });
          p.querySelectorAll('button').forEach(function(btn) {
            btn.setAttribute('style',
              'position: relative !important;' +
              'left: auto !important;' +
              'top: auto !important;' +
              'width: 100% !important;' +
              'box-sizing: border-box !important;' +
              'display: block !important;' +
              'margin-bottom: 8px !important;'
            );
          });
          p.querySelectorAll('input').forEach(function(inp) {
            inp.style.setProperty('position', 'relative', 'important');
            inp.style.setProperty('left', 'auto', 'important');
            inp.style.setProperty('top', 'auto', 'important');
            inp.style.setProperty('width', '100%', 'important');
            inp.style.setProperty('box-sizing', 'border-box', 'important');
            inp.style.setProperty('display', 'block', 'important');
            inp.style.setProperty('margin-bottom', '8px', 'important');
          });
          var titleIds = ['lblLoginTitle', 'lblRegisterTitle',
                          'lblResetTitle', 'lblResetPasswordTitle'];
          titleIds.forEach(function(id) {
            var el = document.getElementById(id);
            if (el) {
              el.style.setProperty('position', 'relative', 'important');
              el.style.setProperty('display', 'block', 'important');
              el.style.setProperty('width', '100%', 'important');
              el.style.setProperty('margin-bottom', '20px', 'important');
              el.style.setProperty('margin-top', '0', 'important');
              el.style.setProperty('left', 'auto', 'important');
              el.style.setProperty('top', 'auto', 'important');
              el.style.setProperty('z-index', '10', 'important');
            }
          });
        }
      });
      var urlParams = new URLSearchParams(window.location.search);
      var token = urlParams.get('token');
      if (token && token.length > 0) {
        window._resetToken = token;
        console.log('Token hittad: ' + token);
        document.getElementById('pnlLogin').style.display = 'none';
        document.getElementById('pnlNewPassword').style.display = 'block';
      }
    }, 100);
  end;

  lblLoginTitle.Caption         := 'Logga in';
  lblRegisterTitle.Caption      := 'Skapa konto';
  lblResetTitle.Caption         := 'Återställ lösenord';
  lblResetPasswordTitle.Caption := 'Nytt lösenord';

  ShowPanel(pnlLogin);
  XDataConn.Connected := True;
end;

procedure TForm1.ShowPanel(const APanel: TPanel);
var
  LActiveId: string;
begin
  pnlLogin.Visible       := APanel = pnlLogin;
  pnlRegister.Visible    := APanel = pnlRegister;
  pnlReset.Visible       := APanel = pnlReset;
  pnlNewPassword.Visible := APanel = pnlNewPassword;
  lblMessage.Visible     := False;
  lblMessage.Caption     := '';

  if APanel = pnlLogin then
    LActiveId := 'pnlLogin'
  else if APanel = pnlRegister then
    LActiveId := 'pnlRegister'
  else if APanel = pnlReset then
    LActiveId := 'pnlReset'
  else if APanel = pnlNewPassword then
    LActiveId := 'pnlNewPassword';

  asm
    var panels = ['pnlLogin', 'pnlRegister', 'pnlReset', 'pnlNewPassword'];
    panels.forEach(function(id) {
      var p = document.getElementById(id);
      if (p) p.style.display = 'none';
    });
    var active = document.getElementById(LActiveId);
    if (active) active.style.display = 'block';
  end;
end;

procedure TForm1.ShowMsg(const AMsg: string; ASuccess: Boolean);
begin
  lblMessage.Visible := True;
  lblMessage.Caption := AMsg;
  if ASuccess then
    lblMessage.ElementClassName := 'alert alert-success mt-2'
  else
    lblMessage.ElementClassName := 'alert alert-danger mt-2';
end;

procedure TForm1.NavigateToElev(AUserId, ACode, AToken, ACodeId: string);
begin
  asm
    sessionStorage.setItem('userId',    AUserId);
    sessionStorage.setItem('userCode',  ACode);
    sessionStorage.setItem('userToken', AToken);
    sessionStorage.setItem('codeId',    ACodeId);
    window.location.href = 'https://dans.mic.tf/elev/DansElevProject.html';
  end;
end;

procedure TForm1.btnLoginClick(Sender: TObject);
var
  LClient: TXDataWebClient;
begin
  if edtLoginEmail.Text.Trim = '' then
  begin
    ShowMsg('Ange epostadress', False);
    Exit;
  end;
  if edtLoginPassword.Text.Trim = '' then
  begin
    ShowMsg('Ange lösenord', False);
    Exit;
  end;
  if edtLoginCode.Text.Trim = '' then
  begin
    ShowMsg('Ange kod', False);
    Exit;
  end;

  LClient := TXDataWebClient.Create(nil);
  LClient.Connection := XDataConn;
  LClient.RawInvoke('IUserService.Login',
    [edtLoginEmail.Text, edtLoginPassword.Text, edtLoginCode.Text],
    procedure(Response: TXDataClientResponse)
    var
      LResult : JS.TJSObject;
      LCode   : string;
      LUserId : string;
      LToken  : string;
      LCodeId : string;
    begin
      LResult := JS.TJSObject(Response.Result);
      Console.Log('Message: ' + string(LResult['Message']));
      Console.Log('Login result: ', LResult);
      Console.Log('Success: ', LResult['Success']);
      if Boolean(LResult['Success']) then
      begin
        LCode   := edtLoginCode.Text;
        LUserId := string(LResult['UserId']);
        LToken  := string(LResult['Token']);
        LCodeId := string(LResult['CodeId']);
        NavigateToElev(LUserId, LCode, LToken, LCodeId);
      end
      else
        ShowMsg(string(LResult['Message']), False);
    end,
    procedure(Error: TXDataClientError)
    begin
      ShowMsg('Fel: ' + Error.ErrorMessage, False);
    end);
end;

procedure TForm1.btnGoToRegisterClick(Sender: TObject);
begin
  ShowPanel(pnlRegister);
end;

procedure TForm1.btnGoToResetClick(Sender: TObject);
begin
  ShowPanel(pnlReset);
end;

procedure TForm1.btnGoToLoginClick(Sender: TObject);
begin
  ShowPanel(pnlLogin);
end;

procedure TForm1.btnResetGotoLoginClick(Sender: TObject);
begin
  ShowPanel(pnlLogin);
end;

procedure TForm1.btnRegisterClick(Sender: TObject);
var
  LClient: TXDataWebClient;
begin
  if edtRegFirstName.Text.Trim = '' then
  begin
    ShowMsg('Ange förnamn', False);
    Exit;
  end;
  if edtRegLastName.Text.Trim = '' then
  begin
    ShowMsg('Ange efternamn', False);
    Exit;
  end;
  if edtRegEmail.Text.Trim = '' then
  begin
    ShowMsg('Ange epostadress', False);
    Exit;
  end;
  if edtRegPassword.Text.Trim = '' then
  begin
    ShowMsg('Ange lösenord', False);
    Exit;
  end;
  if edtRegPassword.Text <> edtRegPassword2.Text then
  begin
    ShowMsg('Lösenorden matchar inte', False);
    Exit;
  end;

  LClient := TXDataWebClient.Create(nil);
  LClient.Connection := XDataConn;
  LClient.RawInvoke('IUserService.Register',
    [edtRegFirstName.Text, edtRegLastName.Text, edtRegMobil.Text,
     edtRegEmail.Text, edtRegPassword.Text],
    procedure(Response: TXDataClientResponse)
    var
      LResult: JS.TJSObject;
    begin
      LResult := JS.TJSObject(Response.Result);
      if Boolean(LResult['success']) then
      begin
        ShowMsg('Konto skapat! Kontrollera din epost för verifiering.', True);
        ShowPanel(pnlLogin);
      end
      else
        ShowMsg(string(LResult['message']), False);
    end,
    procedure(Error: TXDataClientError)
    begin
      Console.Log('Register FEL: ' + Error.ErrorMessage);
    end);
end;

procedure TForm1.btnResetRequestClick(Sender: TObject);
var
  LClient: TXDataWebClient;
begin
  if edtResetEmail.Text.Trim = '' then
  begin
    ShowMsg('Ange epostadress', False);
    Exit;
  end;

  LClient := TXDataWebClient.Create(nil);
  LClient.Connection := XDataConn;
  LClient.RawInvoke('IUserService.ResetRequest', [edtResetEmail.Text],
    procedure(Response: TXDataClientResponse)
    var
      LResult: JS.TJSObject;
    begin
      LResult := JS.TJSObject(Response.Result);
      ShowMsg(string(LResult['Message']), Boolean(LResult['Success']));
    end,
    procedure(Error: TXDataClientError)
    begin
      Console.Log('FEL: ' + Error.ErrorMessage);
    end);
end;

procedure TForm1.btnSaveNewPasswordClick(Sender: TObject);
var
  LClient : TXDataWebClient;
  LToken  : string;
begin
  LToken := '';
  asm
    if (window._resetToken) {
      LToken = window._resetToken;
    }
  end;

  if LToken = '' then
  begin
    ShowMsg('Ingen återställningstoken hittad', False);
    Exit;
  end;
  if edtNewPassword.Text.Trim = '' then
  begin
    ShowMsg('Ange nytt lösenord', False);
    Exit;
  end;
  if edtNewPassword.Text <> edtNewPassword2.Text then
  begin
    ShowMsg('Lösenorden matchar inte', False);
    Exit;
  end;

  LClient := TXDataWebClient.Create(nil);
  LClient.Connection := XDataConn;
  LClient.RawInvoke('IUserService.ResetPassword', [LToken, edtNewPassword.Text],
    procedure(Response: TXDataClientResponse)
    var
      LResult: JS.TJSObject;
    begin
      LResult := JS.TJSObject(Response.Result);
      if Boolean(LResult['Success']) then
      begin
        ShowMsg('Lösenord återställt! Logga in med ditt nya lösenord.', True);
        ShowPanel(pnlLogin);
      end
      else
        ShowMsg(string(LResult['Message']), False);
    end,
    procedure(Error: TXDataClientError)
    begin
      ShowMsg('Fel: ' + Error.ErrorMessage, False);
    end);
end;

procedure TForm1.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlLogin := TPanel.Create('pnlLogin');
  lblLoginTitle := TLabel.Create('lblLoginTitle');
  edtLoginEmail := TEdit.Create(Self);
  edtLoginPassword := TEdit.Create(Self);
  edtLoginCode := TEdit.Create(Self);
  btnLogin := TButton.Create(Self);
  btnGoToRegister := TButton.Create(Self);
  btnGoToReset := TButton.Create(Self);
  pnlRegister := TPanel.Create('pnlRegister');
  lblRegisterTitle := TLabel.Create('lblRegisterTitle');
  edtRegFirstName := TEdit.Create(Self);
  edtRegLastName := TEdit.Create(Self);
  edtRegMobil := TEdit.Create(Self);
  edtRegEmail := TEdit.Create(Self);
  edtRegPassword := TEdit.Create(Self);
  edtRegPassword2 := TEdit.Create(Self);
  btnRegister := TButton.Create(Self);
  btnGoToLogin := TButton.Create(Self);
  pnlReset := TPanel.Create('pnlReset');
  lblResetTitle := TLabel.Create('lblResetTitle');
  edtResetEmail := TEdit.Create(Self);
  btnResetRequest := TButton.Create(Self);
  btnResetGotoLogin := TButton.Create(Self);
  pnlMessage := TPanel.Create('pnlMessage');
  lblMessage := TLabel.Create(Self);
  pnlNewPassword := TPanel.Create('pnlNewPassword');
  lblResetPasswordTitle := TLabel.Create('lblResetPasswordTitle');
  edtNewPassword := TEdit.Create(Self);
  edtNewPassword2 := TEdit.Create(Self);
  btnSaveNewPassword := TButton.Create(Self);
  XDataConn := TXDataWebConnection.Create(Self);

  pnlLogin.BeforeLoadDFMValues;
  lblLoginTitle.BeforeLoadDFMValues;
  edtLoginEmail.BeforeLoadDFMValues;
  edtLoginPassword.BeforeLoadDFMValues;
  edtLoginCode.BeforeLoadDFMValues;
  btnLogin.BeforeLoadDFMValues;
  btnGoToRegister.BeforeLoadDFMValues;
  btnGoToReset.BeforeLoadDFMValues;
  pnlRegister.BeforeLoadDFMValues;
  lblRegisterTitle.BeforeLoadDFMValues;
  edtRegFirstName.BeforeLoadDFMValues;
  edtRegLastName.BeforeLoadDFMValues;
  edtRegMobil.BeforeLoadDFMValues;
  edtRegEmail.BeforeLoadDFMValues;
  edtRegPassword.BeforeLoadDFMValues;
  edtRegPassword2.BeforeLoadDFMValues;
  btnRegister.BeforeLoadDFMValues;
  btnGoToLogin.BeforeLoadDFMValues;
  pnlReset.BeforeLoadDFMValues;
  lblResetTitle.BeforeLoadDFMValues;
  edtResetEmail.BeforeLoadDFMValues;
  btnResetRequest.BeforeLoadDFMValues;
  btnResetGotoLogin.BeforeLoadDFMValues;
  pnlMessage.BeforeLoadDFMValues;
  lblMessage.BeforeLoadDFMValues;
  pnlNewPassword.BeforeLoadDFMValues;
  lblResetPasswordTitle.BeforeLoadDFMValues;
  edtNewPassword.BeforeLoadDFMValues;
  edtNewPassword2.BeforeLoadDFMValues;
  btnSaveNewPassword.BeforeLoadDFMValues;
  XDataConn.BeforeLoadDFMValues;
  try
    Name := 'Form1';
    Width := 640;
    Height := 480;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -15;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlLogin.SetParentComponent(Self);
    pnlLogin.Name := 'pnlLogin';
    pnlLogin.Left := 0;
    pnlLogin.Top := 7;
    pnlLogin.Width := 233;
    pnlLogin.Height := 325;
    pnlLogin.ElementClassName := 'card';
    pnlLogin.ElementBodyClassName := 'card-body';
    pnlLogin.ElementFont := efCSS;
    pnlLogin.TabOrder := 0;
    lblLoginTitle.SetParentComponent(pnlLogin);
    lblLoginTitle.Name := 'lblLoginTitle';
    lblLoginTitle.Left := 16;
    lblLoginTitle.Top := 8;
    lblLoginTitle.Width := 69;
    lblLoginTitle.Height := 19;
    lblLoginTitle.Margins.Left := 2;
    lblLoginTitle.Margins.Top := 2;
    lblLoginTitle.Margins.Right := 2;
    lblLoginTitle.Margins.Bottom := 2;
    lblLoginTitle.Caption := 'Logga in';
    lblLoginTitle.ElementClassName := 'h4 text-center text-primary fw-bold w-100';
    lblLoginTitle.ElementFont := efCSS;
    lblLoginTitle.Font.Charset := DEFAULT_CHARSET;
    lblLoginTitle.Font.Color := clWindowText;
    lblLoginTitle.Font.Height := -16;
    lblLoginTitle.Font.Name := 'Tahoma';
    lblLoginTitle.Font.Style := [fsBold];
    lblLoginTitle.HeightStyle := ssAuto;
    lblLoginTitle.HeightPercent := 100.000000000000000000;
    lblLoginTitle.ParentFont := False;
    lblLoginTitle.WidthStyle := ssAuto;
    lblLoginTitle.WidthPercent := 100.000000000000000000;
    edtLoginEmail.SetParentComponent(pnlLogin);
    edtLoginEmail.Name := 'edtLoginEmail';
    edtLoginEmail.Left := 16;
    edtLoginEmail.Top := 44;
    edtLoginEmail.Width := 192;
    edtLoginEmail.Height := 22;
    edtLoginEmail.ChildOrder := 1;
    edtLoginEmail.ElementClassName := 'form-control mb-2';
    edtLoginEmail.ElementFont := efCSS;
    edtLoginEmail.HeightStyle := ssAuto;
    edtLoginEmail.HeightPercent := 100.000000000000000000;
    edtLoginEmail.TextHint := 'Epostadress';
    edtLoginEmail.WidthPercent := 100.000000000000000000;
    edtLoginPassword.SetParentComponent(pnlLogin);
    edtLoginPassword.Name := 'edtLoginPassword';
    edtLoginPassword.Left := 16;
    edtLoginPassword.Top := 73;
    edtLoginPassword.Width := 192;
    edtLoginPassword.Height := 22;
    edtLoginPassword.ChildOrder := 2;
    edtLoginPassword.ElementClassName := 'form-control mb-2';
    edtLoginPassword.ElementFont := efCSS;
    edtLoginPassword.HeightStyle := ssAuto;
    edtLoginPassword.HeightPercent := 100.000000000000000000;
    edtLoginPassword.PasswordChar := '*';
    edtLoginPassword.TextHint := 'L'#246'senord';
    edtLoginPassword.WidthPercent := 100.000000000000000000;
    edtLoginCode.SetParentComponent(pnlLogin);
    edtLoginCode.Name := 'edtLoginCode';
    edtLoginCode.Left := 16;
    edtLoginCode.Top := 102;
    edtLoginCode.Width := 134;
    edtLoginCode.Height := 22;
    edtLoginCode.ChildOrder := 6;
    edtLoginCode.ElementClassName := 'form-control mb-2';
    edtLoginCode.ElementFont := efCSS;
    edtLoginCode.HeightStyle := ssAuto;
    edtLoginCode.HeightPercent := 100.000000000000000000;
    edtLoginCode.TextHint := 'Kod';
    edtLoginCode.WidthStyle := ssAuto;
    edtLoginCode.WidthPercent := 100.000000000000000000;
    btnLogin.SetParentComponent(pnlLogin);
    btnLogin.Name := 'btnLogin';
    btnLogin.Left := 16;
    btnLogin.Top := 145;
    btnLogin.Width := 192;
    btnLogin.Height := 24;
    btnLogin.Caption := 'Logga in';
    btnLogin.ChildOrder := 3;
    btnLogin.ElementClassName := 'btn btn-primary w-100 mb-2';
    btnLogin.ElementFont := efCSS;
    btnLogin.HeightStyle := ssAuto;
    btnLogin.HeightPercent := 100.000000000000000000;
    btnLogin.WidthPercent := 100.000000000000000000;
    SetEvent(btnLogin, Self, 'OnClick', 'btnLoginClick');
    btnGoToRegister.SetParentComponent(pnlLogin);
    btnGoToRegister.Name := 'btnGoToRegister';
    btnGoToRegister.Left := 16;
    btnGoToRegister.Top := 182;
    btnGoToRegister.Width := 192;
    btnGoToRegister.Height := 26;
    btnGoToRegister.Caption := 'Skapa konto';
    btnGoToRegister.ChildOrder := 4;
    btnGoToRegister.ElementClassName := 'btn btn-outline-secondary w-100 mb-2';
    btnGoToRegister.ElementFont := efCSS;
    btnGoToRegister.HeightStyle := ssAuto;
    btnGoToRegister.HeightPercent := 100.000000000000000000;
    btnGoToRegister.WidthPercent := 100.000000000000000000;
    SetEvent(btnGoToRegister, Self, 'OnClick', 'btnGoToRegisterClick');
    btnGoToReset.SetParentComponent(pnlLogin);
    btnGoToReset.Name := 'btnGoToReset';
    btnGoToReset.Left := 16;
    btnGoToReset.Top := 230;
    btnGoToReset.Width := 192;
    btnGoToReset.Height := 24;
    btnGoToReset.Caption := 'Gl'#246'mt l'#246'senord?';
    btnGoToReset.ChildOrder := 5;
    btnGoToReset.ElementClassName := 'btn btn-link w-100';
    btnGoToReset.ElementFont := efCSS;
    btnGoToReset.HeightStyle := ssAuto;
    btnGoToReset.HeightPercent := 100.000000000000000000;
    btnGoToReset.WidthPercent := 100.000000000000000000;
    SetEvent(btnGoToReset, Self, 'OnClick', 'btnGoToResetClick');
    pnlRegister.SetParentComponent(Self);
    pnlRegister.Name := 'pnlRegister';
    pnlRegister.Left := 156;
    pnlRegister.Top := 7;
    pnlRegister.Width := 233;
    pnlRegister.Height := 448;
    pnlRegister.ElementClassName := 'card';
    pnlRegister.ChildOrder := 1;
    pnlRegister.ElementBodyClassName := 'card-body';
    pnlRegister.ElementFont := efCSS;
    pnlRegister.ElementPosition := epIgnore;
    pnlRegister.TabOrder := 1;
    pnlRegister.Visible := False;
    lblRegisterTitle.SetParentComponent(pnlRegister);
    lblRegisterTitle.Name := 'lblRegisterTitle';
    lblRegisterTitle.Left := 16;
    lblRegisterTitle.Top := 8;
    lblRegisterTitle.Width := 102;
    lblRegisterTitle.Height := 19;
    lblRegisterTitle.Margins.Left := 2;
    lblRegisterTitle.Margins.Top := 2;
    lblRegisterTitle.Margins.Right := 2;
    lblRegisterTitle.Margins.Bottom := 2;
    lblRegisterTitle.Caption := 'Skapa konto';
    lblRegisterTitle.ElementClassName := 'h4 text-center text-success fw-bold w-100';
    lblRegisterTitle.ElementFont := efCSS;
    lblRegisterTitle.Font.Charset := DEFAULT_CHARSET;
    lblRegisterTitle.Font.Color := clWindowText;
    lblRegisterTitle.Font.Height := -16;
    lblRegisterTitle.Font.Name := 'Tahoma';
    lblRegisterTitle.Font.Style := [fsBold];
    lblRegisterTitle.HeightStyle := ssAuto;
    lblRegisterTitle.HeightPercent := 100.000000000000000000;
    lblRegisterTitle.ParentFont := False;
    lblRegisterTitle.WidthStyle := ssAuto;
    lblRegisterTitle.WidthPercent := 100.000000000000000000;
    edtRegFirstName.SetParentComponent(pnlRegister);
    edtRegFirstName.Name := 'edtRegFirstName';
    edtRegFirstName.Left := 16;
    edtRegFirstName.Top := 44;
    edtRegFirstName.Width := 192;
    edtRegFirstName.Height := 22;
    edtRegFirstName.ChildOrder := 1;
    edtRegFirstName.ElementClassName := 'form-control mb-2';
    edtRegFirstName.ElementFont := efCSS;
    edtRegFirstName.HeightStyle := ssAuto;
    edtRegFirstName.HeightPercent := 100.000000000000000000;
    edtRegFirstName.TextHint := 'F'#246'rnamn';
    edtRegFirstName.WidthPercent := 100.000000000000000000;
    edtRegLastName.SetParentComponent(pnlRegister);
    edtRegLastName.Name := 'edtRegLastName';
    edtRegLastName.Left := 16;
    edtRegLastName.Top := 80;
    edtRegLastName.Width := 192;
    edtRegLastName.Height := 22;
    edtRegLastName.ChildOrder := 2;
    edtRegLastName.ElementClassName := 'form-control mb-2';
    edtRegLastName.ElementFont := efCSS;
    edtRegLastName.HeightStyle := ssAuto;
    edtRegLastName.HeightPercent := 100.000000000000000000;
    edtRegLastName.TextHint := 'Efternamn';
    edtRegLastName.WidthPercent := 100.000000000000000000;
    edtRegMobil.SetParentComponent(pnlRegister);
    edtRegMobil.Name := 'edtRegMobil';
    edtRegMobil.Left := 16;
    edtRegMobil.Top := 116;
    edtRegMobil.Width := 192;
    edtRegMobil.Height := 22;
    edtRegMobil.ChildOrder := 3;
    edtRegMobil.ElementClassName := 'form-control mb-2';
    edtRegMobil.ElementFont := efCSS;
    edtRegMobil.HeightStyle := ssAuto;
    edtRegMobil.HeightPercent := 100.000000000000000000;
    edtRegMobil.TextHint := 'Mobilnummer (valfritt)';
    edtRegMobil.WidthPercent := 100.000000000000000000;
    edtRegEmail.SetParentComponent(pnlRegister);
    edtRegEmail.Name := 'edtRegEmail';
    edtRegEmail.Left := 16;
    edtRegEmail.Top := 152;
    edtRegEmail.Width := 192;
    edtRegEmail.Height := 23;
    edtRegEmail.ChildOrder := 4;
    edtRegEmail.ElementClassName := 'form-control mb-2';
    edtRegEmail.ElementFont := efCSS;
    edtRegEmail.HeightStyle := ssAuto;
    edtRegEmail.HeightPercent := 100.000000000000000000;
    edtRegEmail.TextHint := 'Epostadress';
    edtRegEmail.WidthPercent := 100.000000000000000000;
    edtRegPassword.SetParentComponent(pnlRegister);
    edtRegPassword.Name := 'edtRegPassword';
    edtRegPassword.Left := 16;
    edtRegPassword.Top := 188;
    edtRegPassword.Width := 192;
    edtRegPassword.Height := 22;
    edtRegPassword.ChildOrder := 5;
    edtRegPassword.ElementClassName := 'form-control mb-2';
    edtRegPassword.ElementFont := efCSS;
    edtRegPassword.HeightStyle := ssAuto;
    edtRegPassword.HeightPercent := 100.000000000000000000;
    edtRegPassword.PasswordChar := '*';
    edtRegPassword.TextHint := 'L'#246'senord';
    edtRegPassword.WidthPercent := 100.000000000000000000;
    edtRegPassword2.SetParentComponent(pnlRegister);
    edtRegPassword2.Name := 'edtRegPassword2';
    edtRegPassword2.Left := 16;
    edtRegPassword2.Top := 224;
    edtRegPassword2.Width := 192;
    edtRegPassword2.Height := 22;
    edtRegPassword2.ChildOrder := 6;
    edtRegPassword2.ElementClassName := 'form-control mb-2';
    edtRegPassword2.ElementFont := efCSS;
    edtRegPassword2.HeightStyle := ssAuto;
    edtRegPassword2.HeightPercent := 100.000000000000000000;
    edtRegPassword2.PasswordChar := '*';
    edtRegPassword2.TextHint := 'Upprepa l'#246'senord';
    edtRegPassword2.WidthPercent := 100.000000000000000000;
    btnRegister.SetParentComponent(pnlRegister);
    btnRegister.Name := 'btnRegister';
    btnRegister.Left := 16;
    btnRegister.Top := 264;
    btnRegister.Width := 192;
    btnRegister.Height := 25;
    btnRegister.Caption := 'Skapa konto';
    btnRegister.ChildOrder := 7;
    btnRegister.ElementClassName := 'btn btn-success w-100 mb-2';
    btnRegister.ElementFont := efCSS;
    btnRegister.HeightStyle := ssAuto;
    btnRegister.HeightPercent := 100.000000000000000000;
    btnRegister.WidthPercent := 100.000000000000000000;
    SetEvent(btnRegister, Self, 'OnClick', 'btnRegisterClick');
    btnGoToLogin.SetParentComponent(pnlRegister);
    btnGoToLogin.Name := 'btnGoToLogin';
    btnGoToLogin.Left := 16;
    btnGoToLogin.Top := 300;
    btnGoToLogin.Width := 192;
    btnGoToLogin.Height := 25;
    btnGoToLogin.Caption := 'Tillbaka till inloggning';
    btnGoToLogin.ChildOrder := 8;
    btnGoToLogin.ElementClassName := 'btn btn-link w-100';
    btnGoToLogin.ElementFont := efCSS;
    btnGoToLogin.HeightStyle := ssAuto;
    btnGoToLogin.HeightPercent := 100.000000000000000000;
    btnGoToLogin.WidthPercent := 100.000000000000000000;
    SetEvent(btnGoToLogin, Self, 'OnClick', 'btnGoToLoginClick');
    pnlReset.SetParentComponent(Self);
    pnlReset.Name := 'pnlReset';
    pnlReset.Left := 395;
    pnlReset.Top := 87;
    pnlReset.Width := 233;
    pnlReset.Height := 215;
    pnlReset.ElementClassName := 'card';
    pnlReset.ChildOrder := 2;
    pnlReset.ElementBodyClassName := 'card-body';
    pnlReset.ElementFont := efCSS;
    pnlReset.ElementPosition := epIgnore;
    pnlReset.TabOrder := 2;
    pnlReset.Visible := False;
    lblResetTitle.SetParentComponent(pnlReset);
    lblResetTitle.Name := 'lblResetTitle';
    lblResetTitle.Left := 16;
    lblResetTitle.Top := 8;
    lblResetTitle.Width := 146;
    lblResetTitle.Height := 19;
    lblResetTitle.Margins.Left := 2;
    lblResetTitle.Margins.Top := 2;
    lblResetTitle.Margins.Right := 2;
    lblResetTitle.Margins.Bottom := 2;
    lblResetTitle.Caption := #148#145#197'terst'#228'll l'#246'senord';
    lblResetTitle.ElementClassName := 'h4 text-center text-warning fw-bold w-100';
    lblResetTitle.ElementFont := efCSS;
    lblResetTitle.Font.Charset := DEFAULT_CHARSET;
    lblResetTitle.Font.Color := clWindowText;
    lblResetTitle.Font.Height := -16;
    lblResetTitle.Font.Name := 'Tahoma';
    lblResetTitle.Font.Style := [fsBold];
    lblResetTitle.HeightStyle := ssAuto;
    lblResetTitle.HeightPercent := 100.000000000000000000;
    lblResetTitle.ParentFont := False;
    lblResetTitle.WidthStyle := ssAuto;
    lblResetTitle.WidthPercent := 100.000000000000000000;
    edtResetEmail.SetParentComponent(pnlReset);
    edtResetEmail.Name := 'edtResetEmail';
    edtResetEmail.Left := 16;
    edtResetEmail.Top := 44;
    edtResetEmail.Width := 192;
    edtResetEmail.Height := 22;
    edtResetEmail.ChildOrder := 1;
    edtResetEmail.ElementClassName := 'form-control mb-2';
    edtResetEmail.ElementFont := efCSS;
    edtResetEmail.HeightStyle := ssAuto;
    edtResetEmail.HeightPercent := 100.000000000000000000;
    edtResetEmail.TextHint := 'Din epostadress';
    edtResetEmail.WidthPercent := 100.000000000000000000;
    btnResetRequest.SetParentComponent(pnlReset);
    btnResetRequest.Name := 'btnResetRequest';
    btnResetRequest.Left := 16;
    btnResetRequest.Top := 80;
    btnResetRequest.Width := 192;
    btnResetRequest.Height := 25;
    btnResetRequest.Caption := 'Skicka '#229'terst'#228'llningsl'#228'nk';
    btnResetRequest.ChildOrder := 2;
    btnResetRequest.ElementClassName := 'btn btn-warning w-100 mb-2';
    btnResetRequest.ElementFont := efCSS;
    btnResetRequest.HeightStyle := ssAuto;
    btnResetRequest.HeightPercent := 100.000000000000000000;
    btnResetRequest.WidthPercent := 100.000000000000000000;
    SetEvent(btnResetRequest, Self, 'OnClick', 'btnResetRequestClick');
    btnResetGotoLogin.SetParentComponent(pnlReset);
    btnResetGotoLogin.Name := 'btnResetGotoLogin';
    btnResetGotoLogin.Left := 16;
    btnResetGotoLogin.Top := 120;
    btnResetGotoLogin.Width := 192;
    btnResetGotoLogin.Height := 25;
    btnResetGotoLogin.Caption := 'Tillbaka till inloggning';
    btnResetGotoLogin.ChildOrder := 3;
    btnResetGotoLogin.ElementClassName := 'btn btn-link w-100';
    btnResetGotoLogin.ElementFont := efCSS;
    btnResetGotoLogin.HeightStyle := ssAuto;
    btnResetGotoLogin.HeightPercent := 100.000000000000000000;
    btnResetGotoLogin.WidthPercent := 100.000000000000000000;
    SetEvent(btnResetGotoLogin, Self, 'OnClick', 'btnResetGotoLoginClick');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 360;
    pnlMessage.Top := 7;
    pnlMessage.Width := 233;
    pnlMessage.Height := 48;
    pnlMessage.ElementClassName := 'card';
    pnlMessage.ChildOrder := 3;
    pnlMessage.ElementBodyClassName := 'card-body';
    pnlMessage.ElementFont := efCSS;
    pnlMessage.ElementPosition := epIgnore;
    pnlMessage.TabOrder := 3;
    pnlMessage.Visible := False;
    lblMessage.SetParentComponent(pnlMessage);
    lblMessage.Name := 'lblMessage';
    lblMessage.Left := 0;
    lblMessage.Top := 0;
    lblMessage.Width := 5;
    lblMessage.Height := 18;
    lblMessage.ElementClassName := 'alert w-100';
    lblMessage.ElementFont := efCSS;
    lblMessage.HeightStyle := ssAuto;
    lblMessage.HeightPercent := 100.000000000000000000;
    lblMessage.Visible := False;
    lblMessage.WidthPercent := 100.000000000000000000;
    pnlNewPassword.SetParentComponent(Self);
    pnlNewPassword.Name := 'pnlNewPassword';
    pnlNewPassword.Left := 336;
    pnlNewPassword.Top := 189;
    pnlNewPassword.Width := 273;
    pnlNewPassword.Height := 265;
    pnlNewPassword.ElementClassName := 'card';
    pnlNewPassword.ChildOrder := 4;
    pnlNewPassword.ElementBodyClassName := 'card-body';
    pnlNewPassword.ElementFont := efCSS;
    pnlNewPassword.ElementPosition := epIgnore;
    pnlNewPassword.TabOrder := 4;
    lblResetPasswordTitle.SetParentComponent(pnlNewPassword);
    lblResetPasswordTitle.Name := 'lblResetPasswordTitle';
    lblResetPasswordTitle.Left := 35;
    lblResetPasswordTitle.Top := 26;
    lblResetPasswordTitle.Width := 110;
    lblResetPasswordTitle.Height := 19;
    lblResetPasswordTitle.Caption := 'Nytt l'#246'senord';
    lblResetPasswordTitle.ElementClassName := 'h4 text-center text-primary fw-bold w-100';
    lblResetPasswordTitle.ElementFont := efCSS;
    lblResetPasswordTitle.Font.Charset := DEFAULT_CHARSET;
    lblResetPasswordTitle.Font.Color := clWindowText;
    lblResetPasswordTitle.Font.Height := -16;
    lblResetPasswordTitle.Font.Name := 'Tahoma';
    lblResetPasswordTitle.Font.Style := [fsBold];
    lblResetPasswordTitle.HeightStyle := ssAuto;
    lblResetPasswordTitle.HeightPercent := 100.000000000000000000;
    lblResetPasswordTitle.ParentFont := False;
    lblResetPasswordTitle.WidthPercent := 100.000000000000000000;
    edtNewPassword.SetParentComponent(pnlNewPassword);
    edtNewPassword.Name := 'edtNewPassword';
    edtNewPassword.Left := 34;
    edtNewPassword.Top := 72;
    edtNewPassword.Width := 142;
    edtNewPassword.Height := 22;
    edtNewPassword.ElementClassName := 'form-control';
    edtNewPassword.ElementFont := efCSS;
    edtNewPassword.HeightStyle := ssAuto;
    edtNewPassword.HeightPercent := 100.000000000000000000;
    edtNewPassword.PasswordChar := '*';
    edtNewPassword.TextHint := 'Nytt l'#246'senord';
    edtNewPassword.WidthPercent := 100.000000000000000000;
    edtNewPassword2.SetParentComponent(pnlNewPassword);
    edtNewPassword2.Name := 'edtNewPassword2';
    edtNewPassword2.Left := 34;
    edtNewPassword2.Top := 112;
    edtNewPassword2.Width := 142;
    edtNewPassword2.Height := 22;
    edtNewPassword2.ChildOrder := 1;
    edtNewPassword2.ElementClassName := 'form-control';
    edtNewPassword2.ElementFont := efCSS;
    edtNewPassword2.HeightStyle := ssAuto;
    edtNewPassword2.HeightPercent := 100.000000000000000000;
    edtNewPassword2.PasswordChar := '*';
    edtNewPassword2.TextHint := 'Bekr'#228'fta l'#246'senord';
    edtNewPassword2.WidthPercent := 100.000000000000000000;
    btnSaveNewPassword.SetParentComponent(pnlNewPassword);
    btnSaveNewPassword.Name := 'btnSaveNewPassword';
    btnSaveNewPassword.Left := 35;
    btnSaveNewPassword.Top := 150;
    btnSaveNewPassword.Width := 158;
    btnSaveNewPassword.Height := 24;
    btnSaveNewPassword.Caption := 'Spara nytt l'#246'senord';
    btnSaveNewPassword.ChildOrder := 4;
    btnSaveNewPassword.ElementClassName := 'btn btn-primary';
    btnSaveNewPassword.ElementFont := efCSS;
    btnSaveNewPassword.HeightStyle := ssAuto;
    btnSaveNewPassword.HeightPercent := 100.000000000000000000;
    btnSaveNewPassword.WidthPercent := 100.000000000000000000;
    SetEvent(btnSaveNewPassword, Self, 'OnClick', 'btnSaveNewPasswordClick');
    XDataConn.SetParentComponent(Self);
    XDataConn.Name := 'XDataConn';
    XDataConn.URL := 'https://dans.mic.tf/users';
    XDataConn.Left := 454;
    XDataConn.Top := 45;
  finally
    pnlLogin.AfterLoadDFMValues;
    lblLoginTitle.AfterLoadDFMValues;
    edtLoginEmail.AfterLoadDFMValues;
    edtLoginPassword.AfterLoadDFMValues;
    edtLoginCode.AfterLoadDFMValues;
    btnLogin.AfterLoadDFMValues;
    btnGoToRegister.AfterLoadDFMValues;
    btnGoToReset.AfterLoadDFMValues;
    pnlRegister.AfterLoadDFMValues;
    lblRegisterTitle.AfterLoadDFMValues;
    edtRegFirstName.AfterLoadDFMValues;
    edtRegLastName.AfterLoadDFMValues;
    edtRegMobil.AfterLoadDFMValues;
    edtRegEmail.AfterLoadDFMValues;
    edtRegPassword.AfterLoadDFMValues;
    edtRegPassword2.AfterLoadDFMValues;
    btnRegister.AfterLoadDFMValues;
    btnGoToLogin.AfterLoadDFMValues;
    pnlReset.AfterLoadDFMValues;
    lblResetTitle.AfterLoadDFMValues;
    edtResetEmail.AfterLoadDFMValues;
    btnResetRequest.AfterLoadDFMValues;
    btnResetGotoLogin.AfterLoadDFMValues;
    pnlMessage.AfterLoadDFMValues;
    lblMessage.AfterLoadDFMValues;
    pnlNewPassword.AfterLoadDFMValues;
    lblResetPasswordTitle.AfterLoadDFMValues;
    edtNewPassword.AfterLoadDFMValues;
    edtNewPassword2.AfterLoadDFMValues;
    btnSaveNewPassword.AfterLoadDFMValues;
    XDataConn.AfterLoadDFMValues;
  end;
end;

end.
